import logo from "../../Assets/images/protika.png";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { prefixUrl } from "../../Utils/utilsData";

const RegisterForm = (props) => {
  const [sendData, setSendData] = useState({ phoneNumber: "", fullName: "" });
  const loginHandler = () => {
    props.setContent("login");
  };
  const submitData = () => {
    axios
      .post(`${prefixUrl()}/register/sendCode.php`, sendData)
      .then((res) => {
        if (res.data.status) {
          localStorage.setItem("mobile", sendData.phoneNumber);
          localStorage.setItem("name", sendData.fullName);
          props.setContent("verify");
          props.setType("register");
        } else {
          toast.error(res.data.output.error);
        }
      });
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      submitData();
    }
  };
  return (
    <div className="login-form ">
      <div className="login-logo">
        <img src={logo} alt="" />
      </div>
      <div className="panel-input" style={{ marginBottom: "40px" }}>
        <label for=""> نام و نام خانوادگی</label>
        <input
          type="text"
          name="loginphone"
          placeholder="نام و نام خانوادگی را وارد کنید"
          id="mobileOrEmail"
          onChange={(e) =>
            setSendData({ ...sendData, fullName: e.target.value })
          }
        />
      </div>
      <div className="panel-input">
        <label for=""> شماره تلفن/ایمیل </label>
        <input
          type="text"
          name="loginphone"
          placeholder="شماره موبایل یا ایمیل خود را وارد کنید"
          id="mobileOrEmail"
          onChange={(e) =>
            setSendData({ ...sendData, phoneNumber: e.target.value })
          }
          onKeyUp={handleKeyPress}
        />
        <div className="submit-before">
          قبلا ثبت نام کرده ام /<button onClick={loginHandler}>ورود</button>
        </div>
      </div>
      <button type="submit" className="continue-btn" onClick={submitData}>
        ثبت نام
      </button>
    </div>
  );
};

export default RegisterForm;
